import { FC } from 'react';
import { RichTextField } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import styles from './title.module.scss';

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

type Props = {
  title: RichTextField;
};

export const Title: FC<Props> = ({ title }) => {
  return (
    <div className={styles.wrapper}>
      <PrismicRichText field={title} components={components} />
    </div>
  );
};
